export default __webpack_public_path__ + "static/media/mintsite_graphic_7.f78acd9c.png";